import React from "react";
import OrderDetails from "../../components/OrderDetails/OrderDetails";
import DashboardLayout from "../../layouts/DashboardLayout";
import StoreBreadcrumbs from "./components/StoreBreadcrumbs";

const StoreOrderDetailsPage = ({ userInfo, plan }) => (
  <DashboardLayout>
    <StoreBreadcrumbs />
    <OrderDetails
      sales={true}
      userInfo={userInfo}
      plan={plan}
      storeBackUrl="/dashboard-store/orders"
    />
  </DashboardLayout>
);

export default StoreOrderDetailsPage;

